export default (locale) => $fetch(`/api/snippets/messages/${locale}`);
